"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var resolveTextComponent = function (type) {
    switch (type) {
        case 'subdued':
            return Text.Subdued;
        case 'allcaps':
            return Text.AllCaps;
        case 'strong':
            return Text.Strong;
        default:
            return null;
    }
};
var Text = function (props) {
    var TextComponent = resolveTextComponent(props.type);
    if (!TextComponent) {
        return React.createElement("span", null, props.children);
    }
    return React.createElement(TextComponent, __assign({}, automation_attribute_1.default('text'), props));
};
Text.Subdued = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  font-size: 13px;\n  font-weight: ", ";\n"])), tokens_1.colors.text.secondary, tokens_1.fonts.weight.normal);
Text.AllCaps = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 12px;\n  color: ", ";\n  letter-spacing: 1px;\n  text-transform: uppercase;\n"], ["\n  font-size: 12px;\n  color: ", ";\n  letter-spacing: 1px;\n  text-transform: uppercase;\n"])), tokens_1.colors.text.secondary);
Text.Strong = styled_1.default.strong(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: ", ";\n"], ["\n  font-weight: ", ";\n"])), tokens_1.fonts.weight.bold);
Text.defaultProps = {};
exports.default = Text;
var StyledTextAllCaps = Text.AllCaps;
exports.StyledTextAllCaps = StyledTextAllCaps;
var StyledTextSubdued = Text.Subdued;
exports.StyledTextSubdued = StyledTextSubdued;
var Strong = Text.Strong;
exports.Strong = Strong;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=text.js.map